'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPagesTotals = undefined;

var _client = require('../../utils/client');

var _params = require('../../utils/params');

var _justgiving = require('./justgiving');

var _everydayhero = require('./everydayhero');

var fetchPagesTotals = exports.fetchPagesTotals = function fetchPagesTotals() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return (0, _client.isJustGiving)() ? (0, _justgiving.fetchPagesTotals)(params) : (0, _everydayhero.fetchPagesTotals)(params);
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/pages-totals/index.js
// module id = 1328
// module chunks = 0